import { render } from "./ContentOptimisationTableNew.vue?vue&type=template&id=4e2312ac&scoped=true"
import script from "./ContentOptimisationTableNew.vue?vue&type=script&lang=js"
export * from "./ContentOptimisationTableNew.vue?vue&type=script&lang=js"

import "./ContentOptimisationTableNew.vue?vue&type=style&index=0&id=4e2312ac&lang=scss"
import "./ContentOptimisationTableNew.vue?vue&type=style&index=1&id=4e2312ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2312ac"]])

export default __exports__